import { ReactNode } from 'react';
import * as Styles from './styles';

interface ISideMenuProps {
  children: ReactNode;
  width?: string;
  minWidth?: string;
}

const SideMenu = ({
  children,
  width = '35vw',
  minWidth = '200px',
}: ISideMenuProps) => (
  <Styles.Wrapper className="v-d-flex">
    <Styles.List
      width={width}
      minWidth={minWidth}
      className="v-d-flex full-height"
    >
      {children}
    </Styles.List>
  </Styles.Wrapper>
);

export default SideMenu;
